var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('LeftNavBar',{staticClass:"f1",attrs:{"title":_vm.selectedAppInitial,"accordion":true,"items":_vm.navItems,"hasChild":true,"selectedValue":_vm.selectedRole,"selectedParent":_vm.selectedParent},on:{"optionclick":_vm.optionClicked,"accordion":_vm.onRoleSelect,"opened":_vm.parentClicked}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }